import React, { Component } from 'react';
import {
	Button,
	Checkbox,
	Col,
	ControlLabel,
	FormControl,
	FormGroup,
	InputGroup,
	OverlayTrigger,
	Popover,
	Row,
} from 'react-bootstrap';
import DateTime from 'react-datetime';
import Dropzone from 'react-dropzone';
import { connect } from 'react-redux';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import 'style/react-datetime.css';

import { IS_VALID } from 'utils';

import ic_add_image from '../../../assets/image/ic_add_image.svg';
import style from '../../Evoucher/style.less';
import Loader from '../../Loader';

class Create extends Component {
	constructor(props) {
		super(props);

		this.dropzoneRef;

		this.state = {
			isLoadingRelation: false,
		};

		this.getRelation = this.getRelation.bind(this);
	}

	getRelation() {
		let { actions, EWallet, getRelation } = this.props;

		let { formType, selectedData } = EWallet;

		if (
			IS_VALID(selectedData) &&
			(formType.toUpperCase() === 'UPDATE' || formType.toUpperCase() === 'DUPLICATE')
		) {
			this.setState({ isLoadingRelation: true });

			getRelation()
				.then(([cardType, excludedCardType, specificUser, blacklistedUser]) => {
					let cardTypeArray = cardType.map((item) => ({
						label: item.get('name'),
						value: item.id,
					}));

					let excludedCardTypeArray = excludedCardType.map((item) => ({
						label: item.get('name'),
						value: item.id,
					}));

					let specificUserArray = specificUser.map((item) => ({
						label: `${IS_VALID(item.get('memberId')) ? item.get('memberId') : ''} ${
							IS_VALID(item.get('name')) ? item.get('name') : ''
						}`,
						value: item.id,
					}));

					let blacklistedUserArray = blacklistedUser.map((item) => ({
						label: `${IS_VALID(item.get('memberId')) ? item.get('memberId') : ''} ${
							IS_VALID(item.get('name')) ? item.get('name') : ''
						}`,
						value: item.id,
					}));

					this.setState({ isLoadingRelation: false });

					actions.setValue({
						cardType: cardTypeArray,
						excludedCardType: excludedCardTypeArray,
						specificUser: specificUserArray,
						blacklistedUser: blacklistedUserArray,
					});
				})
				.catch((err) => {
					console.log('err', err);
					this.setState({ isLoadingRelation: false });
				});
		}
	}

	render() {
		let { isLoadingRelation } = this.state;

		let {
			EWallet,
			actions,

			loadOptions,
			uploadSpecificUserCSVFile,
		} = this.props;

		let {
			isLoadingAction,

			image,
			imageSize,
			walletCode,
			walletName,
			totalBalanceKey,
			earnedTodayKey,
			balanceKey,
			sort,
			isShowDuration,
			durationStartDate,
			durationEndDate,
			isShowWallet,
			isHideZeroBal,
			isShowRedeem,
			isShowEarnedToday,
			isShowTotalBal,
			isShowHistory,

			cardType,
			excludedCardType,
			specificUser,
			blacklistedUser,
			deviceType,
			isUploadingCSVFile,
			isUploadingCSVFileBlacklistedUser,

			imageSizeOptions,
			deviceTypeOptions,
		} = EWallet;

		let requiredSpan = <span style={{ color: 'red' }}>*</span>;
		let loadingComponent = (
			<div style={{ textAlign: 'center' }}>
				<i className="fa fa-spinner fa-spin"></i>
			</div>
		);
		let popupMessage = (component, message) => {
			return (
				<OverlayTrigger placement="top" id={message} overlay={<Popover>{message}</Popover>}>
					{component}
				</OverlayTrigger>
			);
		};

		let imageSrc = ic_add_image,
			imageStyle = {
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				margin: 'auto',
				width: '100px',
				height: '100%',
			},
			dropZoneStyle = {
				display: 'inline-block',
				verticalAlign: 'top',
			},
			isHideX = {
				display: 'none',
			};

		if (IS_VALID(image)) {
			imageSrc = image.preview || image.url;
			imageStyle = {
				...imageStyle,
				width: '',
				maxWidth: '100%',
				maxHeight: '100%',
			};
			dropZoneStyle = {
				verticalAlign: 'middle',
			};
			isHideX = {};
		}

		let isCardTypeFieldDisabled = specificUser.length !== 0 ? true : false;
		let isSpecificUserFieldDisabled = cardType.length !== 0 ? true : false;

		return (
			<form>
				<Loader loading={isLoadingAction} />
				<Row>
					<Col md={12}>
						<FormGroup style={{ position: 'relative' }}>
							<ControlLabel>Image</ControlLabel>
							<div
								style={{
									position: 'absolute',
									width: '30px',
									height: '30px',
									background: 'red',
									paddingTop: '4px',
									top: '12px',
									right: '-12px',
									textAlign: 'center',
									borderRadius: '50px',
									fontWeight: '600',
									cursor: 'pointer',
									...isHideX,
								}}
								onClick={() => {
									actions.setValue({ image: null });
								}}
							>
								x
							</div>
							<Dropzone
								style={{
									position: '',
									width: '100%',
									height: '200px',
									border: '1px solid #e1e1e1',
									borderRadius: '0px',
									backgroundColor: '#f5f5f5',
									...dropZoneStyle,
								}}
								accept="image/*"
								multiple={false}
								onDropAccepted={(acceptedArray) => {
									actions.setValue({ image: acceptedArray[0] });
								}}
							>
								<img style={imageStyle} src={imageSrc} />
							</Dropzone>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col md={6}>
						<FormGroup>
							<ControlLabel>Wallet Name {requiredSpan}</ControlLabel>
							<FormControl
								placeholder="Enter Wallet Name..."
								value={walletName}
								onChange={(e) => {
									actions.setValue({
										walletName: e.target.value,
									});
								}}
							/>
						</FormGroup>
						<FormGroup>
							<ControlLabel>Wallet Code</ControlLabel>
							<FormControl
								placeholder="Enter Wallet Code..."
								value={walletCode}
								onChange={(e) => {
									actions.setValue({
										walletCode: e.target.value,
									});
								}}
							/>
						</FormGroup>
						<FormGroup>
							<ControlLabel>Sort {requiredSpan}</ControlLabel>
							<FormControl
								type="number"
								placeholder="Enter Sort..."
								value={sort}
								onChange={(e) => {
									actions.setValue({
										sort: e.target.value.replace(/[^0-9.]/g, ''),
									});
								}}
							/>
						</FormGroup>
						<FormGroup>
							<ControlLabel
								style={{
									width: '100%',
									display: 'flex',
									justifyContent: 'space-between',
								}}
							>
								<span>
									Total Balance Key{' '}
									{popupMessage(
										<i className="fa fa-info-circle"></i>,
										'Key/field from $members.login.'
									)}{' '}
									{requiredSpan}
								</span>
							</ControlLabel>
							<FormControl
								placeholder="Enter Total Balance Key..."
								value={totalBalanceKey}
								onChange={(e) => {
									actions.setValue({
										totalBalanceKey: e.target.value,
									});
								}}
							/>
						</FormGroup>
						<FormGroup>
							<ControlLabel>
								Earned Today Key{' '}
								{popupMessage(
									<i className="fa fa-info-circle"></i>,
									'Key/field from points wallet.'
								)}{' '}
								{requiredSpan}
							</ControlLabel>
							<FormControl
								placeholder="Enter Earned Today Key..."
								value={earnedTodayKey}
								onChange={(e) => {
									actions.setValue({
										earnedTodayKey: e.target.value,
									});
								}}
							/>
						</FormGroup>
						<FormGroup>
							<ControlLabel>
								Balance Key{' '}
								{popupMessage(
									<i className="fa fa-info-circle"></i>,
									'Key/field from  $members.getCustomerWallet.'
								)}{' '}
								{requiredSpan}
							</ControlLabel>
							<FormControl
								placeholder="Enter Balance Key..."
								value={balanceKey}
								onChange={(e) => {
									actions.setValue({
										balanceKey: e.target.value,
									});
								}}
							/>
						</FormGroup>
					</Col>
					<Col md={6}>
						<FormGroup>
							<ControlLabel>Image Size</ControlLabel>
							<Select
								clearable={false}
								options={imageSizeOptions}
								value={imageSize}
								onChange={(value) => {
									let stateToUpdate = {
										imageSize: value,
									};

									actions.setValue(stateToUpdate);
								}}
							/>
						</FormGroup>
						<FormGroup>
							<ControlLabel
								style={{
									width: '100%',
									display: 'flex',
									justifyContent: 'space-between',
								}}
							>
								<span>Duration</span>
								<Checkbox
									inline
									checked={isShowDuration}
									onChange={(e) => {
										let stateToUpdate = {
											isShowDuration: e.target.checked,
										};

										if (!e.target.checked) {
											stateToUpdate.durationStartDate = '';
											stateToUpdate.durationEndDate = '';
										}

										actions.setValue(stateToUpdate);
									}}
								>
									Show Duration
								</Checkbox>
							</ControlLabel>
							<DateTime
								dateFormat="MMM DD, YYYY"
								timeFormat="hh:mm A"
								value={durationStartDate}
								onChange={(datetime) => {
									actions.setValue({ durationStartDate: datetime });
								}}
								inputProps={{
									placeholder: 'Start Date',
									disabled: !isShowDuration,
								}}
							/>
						</FormGroup>
						<FormGroup>
							<DateTime
								dateFormat="MMM DD, YYYY"
								timeFormat="hh:mm A"
								value={durationEndDate}
								onChange={(datetime) => {
									actions.setValue({ durationEndDate: datetime });
								}}
								inputProps={{
									placeholder: 'End Date',
									disabled: !isShowDuration,
								}}
							/>
						</FormGroup>
						<FormGroup>
							<Checkbox
								inline={true}
								checked={isShowWallet}
								onChange={(e) => {
									actions.setValue({ isShowWallet: e.target.checked });
								}}
							>
								<b>Show Wallet</b>
							</Checkbox>
						</FormGroup>
						<FormGroup>
							<Checkbox
								inline={true}
								checked={isHideZeroBal}
								onChange={(e) => {
									actions.setValue({ isHideZeroBal: e.target.checked });
								}}
							>
								<b>Hide Zero Balance</b>
							</Checkbox>
						</FormGroup>
						<FormGroup>
							<Checkbox
								inline={true}
								checked={isShowRedeem}
								onChange={(e) => {
									actions.setValue({ isShowRedeem: e.target.checked });
								}}
							>
								<b>Show Redeem</b>
							</Checkbox>
						</FormGroup>
						<FormGroup>
							<Checkbox
								inline={true}
								checked={isShowEarnedToday}
								onChange={(e) => {
									actions.setValue({ isShowEarnedToday: e.target.checked });
								}}
							>
								<b>Show Earned Today</b>
							</Checkbox>
						</FormGroup>
						<FormGroup>
							<Checkbox
								inline={true}
								checked={isShowTotalBal}
								onChange={(e) => {
									actions.setValue({ isShowTotalBal: e.target.checked });
								}}
							>
								<b>Show Total Balance</b>
							</Checkbox>
						</FormGroup>
						<FormGroup>
							<Checkbox
								inline={true}
								checked={isShowHistory}
								onChange={(e) => {
									actions.setValue({ isShowHistory: e.target.checked });
								}}
							>
								<b>Show History</b>
							</Checkbox>
						</FormGroup>
					</Col>
				</Row>
				<hr />
				<Row>
					<Col md={6}>
						<FormGroup>
							<ControlLabel>
								Card Type&nbsp;
								{isCardTypeFieldDisabled
									? popupMessage(
											<i className="fa fa-info-circle"></i>,
											'Specific User is already assigned.'
									  )
									: ''}
							</ControlLabel>
							{isLoadingRelation ? (
								loadingComponent
							) : (
								<Select.Async
									multi={true}
									disabled={isCardTypeFieldDisabled}
									placeholder="Select or Search..."
									loadOptions={(input, cb) =>
										loadOptions(input, cb, 'VoucherCardType', 'name')
									}
									value={cardType}
									onChange={(value) => actions.setValue({ cardType: value })}
									className={style.select}
								/>
							)}
						</FormGroup>
					</Col>
					<Col md={6}>
						<FormGroup>
							<ControlLabel>Excluded Card Type</ControlLabel>
							{isLoadingRelation ? (
								loadingComponent
							) : (
								<Select.Async
									multi={true}
									placeholder="Select or Search..."
									loadOptions={(input, cb) =>
										loadOptions(input, cb, 'VoucherCardType', 'name')
									}
									value={excludedCardType}
									onChange={(value) =>
										actions.setValue({ excludedCardType: value })
									}
									className={style.select}
								/>
							)}
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col md={6}>
						<FormGroup>
							<ControlLabel>Device Type</ControlLabel>
							<Select
								clearable={false}
								options={deviceTypeOptions}
								value={deviceType}
								onChange={(deviceType) => {
									actions.setValue({
										deviceType,
									});
								}}
							/>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col md={6}>
						<FormGroup>
							<ControlLabel>
								Specific User&nbsp;
								{isSpecificUserFieldDisabled
									? popupMessage(
											<i className="fa fa-info-circle"></i>,
											'Card Type is already assigned.'
									  )
									: ''}
								{IS_VALID(specificUser) && specificUser.length > 0
									? `: Total ${specificUser.length}`
									: ''}
							</ControlLabel>
							{isLoadingRelation ? (
								loadingComponent
							) : (
								<div>
									<Select.Async
										placeholder="Select or Search..."
										multi={true}
										disabled={isSpecificUserFieldDisabled}
										loadOptions={(input, cb) =>
											loadOptions(input, cb, 'MemberDetail')
										}
										value={specificUser}
										onChange={(value) =>
											actions.setValue({ specificUser: value })
										}
										className={style.select}
									/>
									<br />
									<Row>
										<Col
											md={
												IS_VALID(specificUser) && specificUser.length > 10
													? 6
													: 12
											}
										>
											<Button
												style={{ width: '100%' }}
												disabled={
													isUploadingCSVFile ||
													isSpecificUserFieldDisabled
												}
												onClick={() => {
													this.dropzoneRef.name = 'specificUser';
													this.dropzoneRef.open();
												}}
											>
												{isUploadingCSVFile ? (
													<i className="fa fa-spinner fa-spin"></i>
												) : (
													<b>UPLOAD SPECIFIC USER CSV</b>
												)}
											</Button>
											<p style={{ margin: '10px 0 0' }}>
												Note: CSV file must have a "memberId" column
											</p>
										</Col>
									</Row>
								</div>
							)}
						</FormGroup>
					</Col>
					<Col md={6}>
						<FormGroup>
							<ControlLabel>
								Excluded User&nbsp;
								{IS_VALID(blacklistedUser) && blacklistedUser.length > 0
									? `: Total ${blacklistedUser.length}`
									: ''}
							</ControlLabel>
							{isLoadingRelation ? (
								loadingComponent
							) : (
								<div>
									<Select.Async
										placeholder="Select or Search..."
										multi={true}
										loadOptions={(input, cb) =>
											loadOptions(input, cb, 'MemberDetail')
										}
										value={blacklistedUser}
										onChange={(value) =>
											actions.setValue({ blacklistedUser: value })
										}
										className={style.select}
									/>
									<br />
									<Row>
										<Col
											md={
												IS_VALID(blacklistedUser) &&
												blacklistedUser.length > 10
													? 6
													: 12
											}
										>
											<Button
												style={{ width: '100%' }}
												disabled={isUploadingCSVFileBlacklistedUser}
												onClick={() => {
													this.dropzoneRef.name = 'blacklistedUser';
													this.dropzoneRef.open();
												}}
											>
												{isUploadingCSVFileBlacklistedUser ? (
													<i className="fa fa-spinner fa-spin"></i>
												) : (
													<b>UPLOAD EXCLUDED USER CSV</b>
												)}
											</Button>
											<p style={{ margin: '10px 0 0' }}>
												Note: CSV file must have a "memberId" column
											</p>
										</Col>
									</Row>
								</div>
							)}
						</FormGroup>
					</Col>
				</Row>
				<Dropzone
					accept=".csv, text/csv"
					style={{ display: 'none' }}
					multiple={false}
					ref={(ref) => {
						this.dropzoneRef = ref;
					}}
					onDropAccepted={(acceptedArray) => {
						uploadSpecificUserCSVFile(acceptedArray[0], this.dropzoneRef.name);
					}}
				/>
			</form>
		);
	}

	componentDidMount() {
		this.getRelation();
	}
}

function mapStateToProps(state) {
	let { EWallet } = state;

	return {
		EWallet,
	};
}

export default connect(mapStateToProps)(Create);



// WEBPACK FOOTER //
// ./components/EWallet/FormContainer/Create.js